<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="course.course_name + ' [Training Course] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/training-courses`">
                            <i class="fa fa-graduation-cap"></i> Training Courses
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/training-courses/view/${course.id}`">
                            {{ course.course_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        Set Bulk Expiration Dates
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-md-6">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Set Expiration Date(s)</strong>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-warning">
                                This will set the Expiration Date for all the following courses. The calculated expiration date is based on the Course's Completed Course Days Valid setting.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-12">

                </div>
            </div>

            <div class="card mb-4">
                <div class="card-header">
                    <strong>Completed Courses</strong>
                </div>
                <div class="card-body">
                    <table class="table table-hover table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>Employee</th>
                                <th>Date Completed</th>
                                <th>Calculated Expiration Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="empCourse in empCourses">
                                <td>{{ empCourse.EmployeeNumber }} - {{ empCourse.FirstName }} {{ empCourse.LastName }}</td>
                                <td>{{ empCourse.completed_at }}</td>
                                <td>{{ getExpirationDate(empCourse.completed_at) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <button type="button" class="btn btn-success" v-on:click="setExpirations()" :disabled="saving">
                <i class="fa fa-save"></i> Set Expiration Dates
            </button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                userTimezone: this.$store.state.user.timezone,
                course: {},
                empCourses: [],
            }
        },

        computed: {

        },

        methods: {

            getData() {
                //Get the data
                this.$http
                    .get('/training-courses/bulk-expiration/' + this.id)
                    .then(response => {
                        //Set all the data
                        this.course = response.data.course;
                        this.empCourses = response.data.empCourses;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            setExpirations() {
                //Saving
                this.saving = true;

                //Get the data
                this.$http
                    .post('/training-courses/bulk-expiration/' + this.id)
                    .then(response => {
                        //Alert the user?
                        this.$toastr.success('Expiration Dates Set');

                        //Return to main list?
                        this.$router.push('/training-courses/view/' + this.id);
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Saving
                        this.saving = false;
                    });
            },

            getExpirationDate(completed_at){
                console.log(completed_at);

                //Increment the Date
                var completedDate = moment(completed_at, 'MM/DD/YYYY');

                //Add the number of days
                completedDate.add(this.course.valid_days, 'days');

                //Set it
                return completedDate.format('MM/DD/YYYY');
            },

        },

        mounted() {
            //Get the Training Course
            this.getData();
        }
    }
</script>
